import type { Entities } from "../types"

export const entities: Entities = new Map([
  [
    "euler-dao",
    {
      name: "Euler DAO",
      logo: "entities/euler.svg",
      description:
        "The Euler DAO is the organisation responsible for the creation of the Euler lending/borrowing platform.",
      url: "https://euler.finance/",
      addresses: {
        "0xf6d781B96b65495f8b0429f3023Df2194AfCF06F": "Euler DAO Multisig",
        "0x09d43F5C713239d6E450CD231EA36e9e78a45c68":
          "Euler Vault Access Control Governor",
      },
      social: {
        twitter: "eulerfinance",
        youtube: "EulerFinance",
        discord: "https://discord.euler.finance/",
        telegram: "eulerfinance_official",
        github: "euler-xyz",
      },
    },
  ],
  [
    "gauntlet",
    {
      name: "Gauntlet",
      logo: "entities/gauntlet.svg",
      description:
        "Gauntlet's applied research and optimization teams model market risk, economic incentives, and drive sustainable growth for crypto's top protocols, chains, and onchain treasuries.",
      url: "https://www.gauntlet.xyz/",
      addresses: {
        "0x09d43F5C713239d6E450CD231EA36e9e78a45c68":
          "Euler Vault Access Control Governor",
      },
      social: { twitter: "gauntlet_xyz" },
    },
  ],
  [
    "alphagrowth",
    {
      name: "AlphaGrowth",
      logo: "entities/alphagrowth.svg",
      description:
        "Real stewardship, real growth. AlphaGrowth drives the blockchain industry forward by expanding token utility and accessibility through strategic partnerships and integrations.",
      url: "https://alphagrowth.io/",
      addresses: {
        "0x4f894Bfc9481110278C356adE1473eBe2127Fd3C": "Reservoir DAO Multisig",
      },
      social: { twitter: "alphagrowth1" },
    },
  ],
])
